export default __webpack_public_path__ + "static/media/activityBg4.84712744.png";